export enum ServicesEnum {
    IME = 1,
    TCM = 2,
    PT = 3,
    Diagnostic = 4,
    UR = 5,
    TT = 6,
    DME = 7,
}
